import { FC } from 'react'

import XIcon from '@heroicons/react/outline/XIcon'
import { NodeViewProps } from '@tiptap/react'

import { Embed as EmbedType } from '@tribeplatform/gql-client/types'

import { Container } from '../Container'

export const Embed: FC<NodeViewProps> = props => {
  const { node, deleteNode, getPos, editor } = props
  const embed = node.attrs.embed as EmbedType

  if (!embed) return null

  const previewProps = {
    dangerouslySetInnerHTML: { __html: embed?.html || 'Something went wrong' },
  }
  const onRemove = () => {
    const position = getPos() - 2
    const { url } = embed
    deleteNode()
    editor
      .chain()
      .focus(position)
      .insertLink({ href: url })
      .insertContent(' ')
      .run()
  }

  return (
    <Container {...props}>
      <div {...previewProps} />
      <div
        onClick={onRemove}
        className="flex absolute top-1 right-1 p-1 cursor-pointer w-8 h-8 items-center justify-center bg-surface-50 rounded-full border"
      >
        <XIcon />
      </div>
    </Container>
  )
}
